<template>
  <validation-observer v-if="dialogComputed" ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="dialogComputed" max-width="400px" scrollable :persistent="!isInquiry">
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ setting.title }}
          <v-spacer />
          <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <v-container fluid class="px-0">
            <v-row>
              <v-col>
                <TextFieldRef v-if="isEdit || isInquiry" :label="$t('ELE0026')" :value="measInstCdComputed" />
                <TextFieldInput
                  v-else
                  :label="$t('ELE0026')"
                  v-model="measInstCdComputed"
                  :maxLength="20"
                  validationMode="aggressive"
                  :debounce="500"
                  rules="alphaNum|measInstCdUnique"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef v-if="isInquiry" :label="$t('ELE0027')" :value="measInstNameComputed" />
                <TextFieldInput v-else :label="$t('ELE0027')" v-model="measInstNameComputed" :maxLength="40" required />
              </v-col>
            </v-row>
            <v-row v-if="isInquiry || isEdit">
              <v-col>
                <BtnChooseValid v-model="isValidComputed" :disabled="isInquiry" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <span class="d-flex flex-row space-between">
            <BtnClose v-if="isInquiry" @click="close" />
            <BtnSave v-else @click="onClickSave" :disabled="invalid" />
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import { API } from '@/plugins/api'
import { ValidationObserver } from 'vee-validate'
import { ModalMode } from '@/enum'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import Btn from '@/components/atoms/base/button/Btn'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnClose from '@/components/atoms/button/BtnClose'
import BtnChooseValid from '@/components/atoms/button/BtnChooseValid'

export default {
  name: 'MeasInstDialog',
  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldRef,
    Btn,
    BtnSave,
    BtnClose,
    BtnChooseValid,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    measInstCd: {
      type: String,
      required: true,
    },
    measInstName: {
      type: String,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
    versionNo: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      settings: [
        {
          mode: ModalMode.ADD,
          title: this.$t('ELE0016'),
          url: '/master/measInsts/register',
        },
        {
          mode: ModalMode.EDIT,
          title: this.$t('ELE0017'),
          url: '/master/measInsts/{id}/update',
        },
        {
          mode: ModalMode.INQUIRY,
          title: this.$t('ELE0018'),
          url: '',
        },
      ],
    }
  },
  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    measInstCdComputed: {
      get() {
        return this.measInstCd
      },
      set(value) {
        if (value) {
          value = value.trim()
        }
        this.$emit('update:measInstCd', value)
      },
    },
    measInstNameComputed: {
      get() {
        return this.measInstName
      },
      set(value) {
        this.$emit('update:measInstName', value)
      },
    },
    isValidComputed: {
      get() {
        return this.isValid
      },
      set(value) {
        this.$emit('update:isValid', value)
      },
    },
    versionNoComputed: {
      get() {
        return this.versionNo
      },
    },
    setting: {
      get() {
        return this.settings.find((el) => el.mode === this.mode)
      },
    },
    isEdit: {
      get() {
        return this.setting.mode === ModalMode.EDIT
      },
    },
    isInquiry: {
      get() {
        return this.setting.mode === ModalMode.INQUIRY
      },
    },
  },
  methods: {
    close() {
      this.dialogComputed = false
    },
    async onClickSave() {
      this.startLoading()

      try {
        if (!(await this.$refs.observer.validate())) {
          return
        }
        const body = {
          measInstCd: this.measInstCd,
          measInstName: this.measInstName,
          isValid: this.isValid,
          versionNo: this.versionNo,
        }
        const url = this.setting.url.replace('{id}', this.measInstCd)
        await API.post(url, body)

        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0025') }))
        this.close()
        this.$emit('change')
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0025') })))
      } finally {
        this.stopLoading()
      }
    },
  },
}
</script>
